import {formatMoney} from "../../../utils/pricing";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import {useCartAmounts} from "../../../hooks/useCartAmounts";

const getAppliedDiscounts = (source) =>
  Array.isArray(source?.Discounts) ? source.Discounts : Array.isArray(source?.discounts) ? source.discounts : [];

const getDiscountName = (discount) =>
  discount?.name ?? discount?.title ?? discount?.discountCode ?? discount?.code ?? "Descuento";

export const OrderTotals = () => {
  const [expanded,setExpanded] = useState(false);
  const cart = useSelector((state) => state.aplicationConfig.userConfig.cart);
  const order = useSelector((state) => state.aplicationConfig.userConfig.order);

  const isOrder = Boolean(order?.orderId);
  const appliedDiscounts = useMemo(() => getAppliedDiscounts(isOrder ? order : cart), [cart, isOrder, order]);


  const quote = useCartAmounts();
  const amounts = isOrder ? order?.amounts : (quote.amounts || quote.displayAmounts);
  const grossSubtotal = amounts?.subtotal;
  const discountAmount = amounts?.discounts;
  const deliveryAmount = amounts?.shipping;
  const taxes = amounts?.tax;
  const total = amounts?.total;
  const discountLabel = appliedDiscounts.map(getDiscountName).filter(Boolean).join(" · ");
  const taxRows = amounts?.taxes || [];


  if (!amounts) return <div role={quote.error || isOrder ? "alert" : "status"}>{isOrder ? "El importe de este pedido necesita revisión antes del cobro." : quote.error ? <>No se pudo calcular el importe. <button type="button" onClick={quote.retry}>Reintentar</button></> : "Calculando el importe…"}</div>;

  return (
    <div className="order-commander-totals" aria-busy={!isOrder && quote.busy}>
      {!isOrder && (quote.busy || quote.error) && <p className="tpvQuoteNotice" role={quote.error ? "alert" : "status"}>{quote.error ? <>No se pudo actualizar el importe. <button type="button" onClick={quote.retry}>Reintentar</button></> : "Actualizando importes…"} <small>Último cálculo confirmado. Cobro pendiente de actualización.</small></p>}
      <div className={`order-commander-totals-container ${expanded ? "is-expanded" : ""}`} id="tpv-total-breakdown">
        <div className="order-commander-totals-row">
          <div className="order-commander-total-row-label">Subtotal sin IVA</div>

          <div className="order-commander-total-row-value">{formatMoney(grossSubtotal)}</div>
        </div>

        <div className="order-commander-totals-row tpvExtraAmountRow">
          <div className="order-commander-total-row-label">Entrega</div>
          <div className="order-commander-total-row-info"> </div>
          <div className="order-commander-total-row-value">{formatMoney(deliveryAmount)}</div>
        </div>

        <div className="order-commander-totals-row">
          <div className="order-commander-total-row-label">Descuento</div>
          <div className="order-commander-total-row-info">{discountLabel}</div>
          <div className="order-commander-total-row-value">
            {formatMoney(discountAmount > 0 ? -discountAmount : 0)}
          </div>
        </div>

        {taxRows.length > 0 ? (
          taxRows.map((taxRow, index) => (
            <div className="order-commander-totals-row tpvExtraAmountRow" key={taxRow.rate}>
              <div className="order-commander-total-row-label">{index === 0 ? "Impuestos" : ""}</div>
              <div className="order-commander-total-row-info">{Number(taxRow.rate.toFixed(2)).toLocaleString("es-ES")}% de IVA</div>
              <div className="order-commander-total-row-value">{formatMoney(taxRow.amount)}</div>
            </div>
          ))
        ) : (
          <div className="order-commander-totals-row tpvExtraAmountRow">
            <div className="order-commander-total-row-label">Impuestos</div>
            <div className="order-commander-total-row-info">IVA incluido</div>
            <div className="order-commander-total-row-value">{formatMoney(taxes)}</div>
          </div>
        )}
        <button type="button" className="tpvBreakdownToggle" aria-label={expanded ? "Ocultar desglose de importes" : "Ver desglose de importes"} title={expanded ? "Ocultar desglose" : "Ver desglose"} aria-expanded={expanded} aria-controls="tpv-total-breakdown" onClick={()=>setExpanded(!expanded)}>{expanded ? "⌃" : "⌄"}</button>
      </div>

      <div className="order-commander-totals-resume">
        <div className="order-commander-totals-resume-label">Total</div>
        <div className="order-commander-totals-resume-value">{formatMoney(total)}</div>
      </div>
    </div>
  );
};
